export default __webpack_public_path__ + "static/media/Medium-branded-DeepRacer-GUI-bordered-350px-224px.jpg.3a701d21.webp";